import { TableBody, TableCell, TableRow } from '@/components/table';

export interface ViolationsNoRecordsProps {
  noOfColumns: number;
}

export function ViolationsNoRecords({ noOfColumns }: ViolationsNoRecordsProps) {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={noOfColumns}>
          <p className="text-gray-500 text-center">No violations data found</p>
        </TableCell>
      </TableRow>
    </TableBody>
  );
}

export default ViolationsNoRecords;
